module.exports = __webpack_public_path__ + "img/tagclose.20535f59.svg";